var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagramIcon = function SvgInstagramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0C7.611 0 0 7.611 0 17s7.611 17 17 17 17-7.611 17-17S26.389 0 17 0Zm4.48 7h-8.96A5.525 5.525 0 0 0 7 12.52v8.96A5.525 5.525 0 0 0 12.52 27h8.96A5.526 5.526 0 0 0 27 21.48v-8.96A5.525 5.525 0 0 0 21.48 7Zm3.745 14.48a3.75 3.75 0 0 1-3.744 3.745h-8.962a3.749 3.749 0 0 1-3.745-3.744v-8.962a3.749 3.749 0 0 1 3.745-3.745h8.961a3.75 3.75 0 0 1 3.745 3.745v8.962ZM17 11.848A5.16 5.16 0 0 0 11.846 17a5.16 5.16 0 0 0 5.153 5.154A5.16 5.16 0 0 0 22.153 17a5.16 5.16 0 0 0-5.154-5.153Zm0 8.532A3.383 3.383 0 0 1 13.62 17 3.383 3.383 0 0 1 17 13.621a3.383 3.383 0 0 1 3.378 3.38A3.383 3.383 0 0 1 17 20.378Zm5.37-10.037a1.306 1.306 0 0 0-1.3 1.301c0 .342.139.678.382.92.24.242.577.382.919.382.343 0 .677-.14.92-.381a1.307 1.307 0 0 0 0-1.84 1.307 1.307 0 0 0-.92-.382Z",
    fill: "#2C112D"
  })));
};
export default SvgInstagramIcon;